module.exports = __webpack_public_path__ + "static/img/ad4-1.2b9dc42.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark40/ad4-1.png
// module id = +vuc
// module chunks = 12